import { useState, useEffect } from "react";
import { jwtFetch } from "./utils/apiClient";
import { useParams, useNavigate } from "react-router-dom";
import Select from 'react-select';
import { format } from "date-fns";
import { config, priceFormat, numberFormat } from "./Components/Config";
import Menu from "./Components/Menu";
import Header from "./Components/Header";

const LeadOpportunity = () => {
  const { id_lead } = useParams();
  const [ lead, setLead ] = useState(null);
  const [ opportunityDealType, setOpportunityDealType ] = useState(null);
  const [ opportunityProductLine, setOpportunityProductLine ] = useState(null);
  const [ opportunityProductDetail, setOpportunityProductDetail ] = useState('');
  const [ opportunityProductMonths, setOpportunityProductMonths ] = useState(0);
  const [ opportunityExpectedClosed, setOpportunityExpectedClosed ] = useState(format(new Date(), 'yyyy-MM-dd'));
  const [ opportunityExpectedRevenue, setOpportunityExpectedRevenue ] = useState(0);
  const [ opportunityExpectedProfit, setOpportunityExpectedProfit ] = useState(0);
  const [ opportunityRemarks, setOpportunityRemarks ] = useState('');
  const [ isLoadingSubmit, setIsLoadingSubmit ] = useState(false);

  const navigate = useNavigate();

  const crmUser = JSON.parse(localStorage.getItem('crmUser'));

  const dealTypeOptions = [
    { value: 'New Business', label: 'New Business' },
    { value: 'Cross Selling', label: 'Cross Selling' },
    { value: 'Exist Additional', label: 'Exist Additional' },
    { value: 'Renew Only', label: 'Renew Only' },
    { value: 'Upgrade', label: 'Upgrade' },
  ];

  const productLineOptions = [
    { label: 'GWS SMB', value: 'GWS SMB' },
    { label: 'GWS CORP', value: 'GWS CORP' },
    { label: 'GWS ENTERPRISE', value: 'GWS ENTERPRISE' },
    { label: 'CHROME ENTERPRISE', value: 'CHROME ENTERPRISE' },
    { label: 'CHROME EDUCATION', value: 'CHROME EDUCATION' },
    { label: 'HARDWARE', value: 'HARDWARE' },
    { label: 'EDUCATION LICENSES', value: 'EDUCATION LICENSES' },
    { label: 'TRAINING', value: 'TRAINING' },
    { label: 'SERVICES', value: 'SERVICES' },
    { label: 'MICROSOFT', value: 'MICROSOFT' },
    { label: 'GOOGLE CLOUD', value: 'GOOGLE CLOUD' },
    { label: 'GEMINI ENTERPRISE', value: 'GEMINI ENTERPRISE' },
    { label: 'APIGEE', value: 'APIGEE' },
    { label: 'LUMAPPS', value: 'LUMAPPS' },
    { label: 'JUMPCLOUD', value: 'JUMPCLOUD' },
    { label: 'OTHER LICENSES', value: 'OTHER LICENSES' },
    { label: 'CUSTOM APPS', value: 'CUSTOM APPS' },
    { label: 'KAMIGAWE LICENSES', value: 'KAMIGAWE LICENSES' },
    { label: 'KAMIGAWE SERVICES', value: 'KAMIGAWE SERVICES' },
    { label: 'SAAS APPS (ALBAN)', value: 'SAAS APPS (ALBAN)' }
  ];

  useEffect(() => {
    getLead();
  }, []);

  const getLead = async () => {
    try {
      const requestGetLead = {
        "id_lead": id_lead
      }
      const fetchGetLead = await jwtFetch(config.ENDPOINT + 'get/lead', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestGetLead)
      });
      const responseGetLead = await fetchGetLead.json();
      if (responseGetLead.status === 200) {
        setLead(responseGetLead.data[0]);
        if (responseGetLead.data[0].lead_category) {
          setOpportunityProductLine({ 
            value: responseGetLead.data[0].lead_category,
            label: responseGetLead.data[0].lead_category
          });
        }
        setOpportunityProductDetail(responseGetLead.data[0].lead_products || '');
        setOpportunityRemarks(responseGetLead.data[0].lead_remarks || '');
      } else {
        alert(responseGetLead.message);
      }
    } catch (error) {
      console.error('Error in getLead:', error);
      alert('An error occurred: ' + (error.message || error));
    }
  };

  const addOpportunity = async (e) => {
    try {
      e.preventDefault();
      setIsLoadingSubmit(true);

      const requestOpportunityAdd = {
        "lead_id": lead.id_lead,
        "opportunity_enquiry": lead.lead_enquiry,
        "opportunity_open_for": 0,
        "opportunity_expected_closed": opportunityExpectedClosed,
        "opportunity_deal_type": opportunityDealType.value,
        "opportunity_product_line": opportunityProductLine.value,
        "opportunity_product_detail": opportunityProductDetail,
        "opportunity_product_months": opportunityProductMonths,
        "opportunity_expected_revenue": opportunityExpectedRevenue,
        "opportunity_expected_profit": opportunityExpectedProfit,
        "opportunity_remarks": opportunityRemarks,
        "opportunity_status": 'Open',
        "assigned_to": lead.assigned_to,
        "created_on": format(new Date(), 'yyyy-MM-dd HH:mm:ss'),
        "created_by": crmUser.user_keyid,
      }

      const fetchOpportunityAdd = await jwtFetch(config.ENDPOINT + 'create/lead_opportunity', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestOpportunityAdd)
      });
      const responseOpportunityAdd = await fetchOpportunityAdd.json();
      if (responseOpportunityAdd.status === 200) {
        window.location.href = '/opportunity/detail/' + responseOpportunityAdd.data.insertId;
      } else {
        console.log(responseOpportunityAdd.message);
        setIsLoadingSubmit(false);
      }
    } catch (error) {
      console.error('Error in addOpportunity:', error);
      alert('An error occurred: ' + (error.message || error));
      setIsLoadingSubmit(false);
    }
  }
  
  return (
    <div id="lead-opty">
      <div className="container-fluid p-0">
        <div className="row g-0 mh-100vh">
          <div className="col-md-2 border-end">
            <div className="d-md-flex d-none align-items-center justify-content-center p-1 h-48">
              <a className="h-100" href="/dashboard"><img className="h-100" src="/cuancuan.png" alt="PointStar"/></a>
            </div>
            <hr className="m-0"/>
            <Menu active="lead"/>
          </div>
          <div className="col-md-10">
            <Header/>
            <hr className="m-0"/>
            <div className="main">
              <div className="p-4">
                
                {lead ? (
                  <section className="mb-4">
                    <div className="d-flex align-items-center justify-content-between mb-3">
                      <div className="d-flex align-items-center">
                        <div className="fs-24"><button className="btn btn-link" onClick={() => navigate(-1)}><i className="bi bi-arrow-left"/></button> Opportunity Add</div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="row mb-2">
                          <div className="col-md-4 text-secondary">Company Group</div>
                          <div className="col-md-8">{lead.company_name} <a href={"/client/detail/" + lead.company_id}><i className="bi bi-link-45deg"/></a></div>
                        </div>
                        <div className="row mb-2">
                          <div className="col-md-4 text-secondary">Subsidiary</div>
                          <div className="col-md-8">{lead.subcompany_name} <a href={"/client/subsidiary/detail/" + lead.subcompany_id}><i className="bi bi-link-45deg"/></a></div>
                        </div>
                        <div className="row mb-2">
                          <div className="col-md-4 text-secondary">Contact Person</div>
                          <div className="col-md-8">{lead.contact_name} <a href={"/client/contact/detail/" + lead.contact_id}><i className="bi bi-link-45deg"/></a></div>
                        </div>
                        <div className="row mb-2">
                          <div className="col-md-4 text-secondary">Created Date</div>
                          <div className="col-md-8">{format(new Date(lead.created_on), 'd MMM yyyy')}</div>
                        </div>
                        <div className="row mb-2">
                          <div className="col-md-4 text-secondary">Marketing Person</div>
                          <div className="col-md-8">{lead.marketing_name}</div>
                        </div>
                        <div className="row mb-2">
                          <div className="col-md-4 text-secondary">Sales Person</div>
                          <div className="col-md-8">{lead.sales_name}</div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="card mb-2">
                          <div className="card-body">
                            <div className="d-flex align-items-center justify-content-between">
                              <p className="fs-14 mb-0"><strong>Lead</strong></p>
                              <a href={"/lead/detail/" + lead.id_lead} target="_blank" rel="noopener noreferrer">{lead.lead_code} <i className="bi bi-link-45deg ms-1"/></a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                ) : (
                  <p>No data</p>
                )}
                
                {lead && (
                  <section className="mb-4">
                    <div className="card mb-4">
                      <div className="card-body">
                        <div className="d-flex align-items-center justify-content-between mb-2">
                          <p className="fs-14 mb-0"><strong>Enquiry & BANT</strong></p>
                        </div>
                        <div className="p-2">
                          <div className="row mb-2">
                            <div className="col-md-2 text-secondary">Message</div>
                            <div className="col-md-10">{lead.lead_enquiry}</div>
                          </div>
                          <div className="row mb-2">
                            <div className="col-md-2 text-secondary">Budget</div>
                            <div className="col-md-10">{priceFormat(lead.bant_budget, 'IDR')}</div>
                          </div>
                          <div className="row mb-2">
                            <div className="col-md-2 text-secondary">Authority</div>
                            <div className="col-md-10">{lead.bant_authority}</div>
                          </div>
                          <div className="row mb-2">
                            <div className="col-md-2 text-secondary">Need</div>
                            <div className="col-md-10">{lead.bant_need}</div>
                          </div>
                          <div className="row">
                            <div className="col-md-2 text-secondary">Timeline</div>
                            <div className="col-md-10">{lead.bant_timeline}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                )}
                
                {lead && (
                  <section className="mb-4">
                    <div className="card mb-4">
                      <div className="card-body">
                        <div className="d-flex align-items-center justify-content-between mb-2">
                          <p className="fs-14 mb-0"><strong>Remarks</strong></p>
                        </div>
                        <div className="p-2">
                          <div className="row mb-2">
                            <div className="col-md-2 text-secondary">Marketing</div>
                            <div className="col-md-10">{lead.source_remarks}</div>
                          </div>
                          <div className="row">
                            <div className="col-md-2 text-secondary">Sales</div>
                            <div className="col-md-10">{lead.lead_remarks}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                )}

                <section className="mb-4">
                  <form onSubmit={(e) => addOpportunity(e)}>
                    <div className="mt-4 mb-2">
                      <div className="d-flex align-items-center justify-content-between mb-3">
                        <div className="fs-24">Details</div>
                      </div>
                      <div className="row">
                        <div className="col-md-6">
                          <div className="row align-items-baseline form-group mb-2">
                            <div className="col-md-4">
                              <label>Product Line</label>
                            </div>
                            <div className="col-md-8">
                              <Select options={productLineOptions} value={opportunityProductLine} onChange={(value) => setOpportunityProductLine(value)} />
                            </div>
                          </div>
                          <div className="row align-items-baseline form-group mb-2">
                            <div className="col-md-4">
                              <label>Product Details</label>
                            </div>
                            <div className="col-md-8">
                              <textarea className="form-control" rows="4" value={opportunityProductDetail} onChange={(e) => setOpportunityProductDetail(e.target.value)} />
                            </div>
                          </div>
                          <div className="row align-items-baseline form-group mb-2">
                            <div className="col-md-4">
                              <label>Deal Type</label>
                            </div>
                            <div className="col-md-8">
                              <Select options={dealTypeOptions} value={opportunityDealType} onChange={(value) => setOpportunityDealType(value)} />
                            </div>
                          </div>
                          <div className="row form-group align-items-center mb-2">
                            <div className="col-md-4">
                              <label>Remarks</label>
                            </div>
                            <div className="col-md-8">
                              <textarea className="form-control" rows="4" value={opportunityRemarks} onChange={(e) => setOpportunityRemarks(e.target.value)} />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="card mb-2">
                            <div className="card-body">
                              <div className="row form-group align-items-center mb-2">
                                <div className="col-md-4">
                                  <label>Months</label>
                                </div>
                                <div className="col-md-8">
                                  <input className="form-control text-end" type="number" value={opportunityProductMonths} onChange={(e) => setOpportunityProductMonths(numberFormat(e.target.value))}/>
                                </div>
                              </div>
                              <div className="row form-group align-items-center">
                                <div className="col-md-4">
                                  <label>Expected Closing Date</label>
                                </div>
                                <div className="col-md-8">
                                  <input className="form-control" type="date" value={opportunityExpectedClosed} onChange={(e) => setOpportunityExpectedClosed(e.target.value)}/>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="card mb-2">
                            <div className="card-body">
                              <div className="row form-group align-items-center mb-2">
                                <div className="col-md-4">
                                  <label>Estimated Revenue</label>
                                </div>
                                <div className="col-md-8">
                                  <div className="input-group">
                                    <input className="form-control text-end" type="text" value={priceFormat(opportunityExpectedRevenue)} onChange={(e) => setOpportunityExpectedRevenue(numberFormat(e.target.value))}/>
                                    <span className="input-group-text mw-85">IDR</span>
                                  </div>
                                </div>
                              </div>
                              <div className="row form-group align-items-center">
                                <div className="col-md-4">
                                  <label>Estimated Profit</label>
                                </div>
                                <div className="col-md-8">
                                  <div className="input-group">
                                    <input className="form-control text-end" type="text" value={priceFormat(opportunityExpectedProfit)} onChange={(e) => setOpportunityExpectedProfit(numberFormat(e.target.value))}/>
                                    <span className="input-group-text mw-85">IDR</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="d-flex justify-content-end">
                      <button className="btn btn-outline-primary" type="submit" disabled={isLoadingSubmit}>{isLoadingSubmit ? 'Loading...' : 'Save'}</button>
                    </div>
                  </form>
                </section>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LeadOpportunity;


